import { AppState } from '../../app/state/AppState';

export function selectFlowsOnSiteEnabled(state: AppState) {
  return state.session && state.session.info && state.session.info.site &&
    state.session.info.site.flowsOnSiteEnabled !== false;
}

export function selectEditingFlowsEnabled(state: AppState) {
  return state && state.session && state.session.info && state.session.info.site &&
    state.session.info.site.editingFlowsEnabled !== false;
}

export function selectSchedulingFlowsEnabled(state: AppState) {
  return state && state.session && state.session.info && state.session.info.site &&
    state.session.info.site.schedulingFlowsEnabled !== false;
}
